import React from 'react'
import { Link } from 'react-router-dom'

export default function Breadcrumb({ links }) {
  return (
    <nav
      aria-label="breadcrumb"
      className="w-max"
    >
      <ol className="flex w-full flex-wrap items-center text-sm font-semibold">
        <li className="flex items-center">
          <span className="cursor-default p-1 pr-0 text-muted-700">
            الرئيسية
          </span>
          <span className="pointer-events-none">/</span>
        </li>
        {links?.map((link) => (
          <li
            key={link.id}
            className="flex items-center"
          >
            {link.isActive ? (
              <span className="cursor-default p-1"> {link.label}</span>
            ) : (
              <Link
                to={link.to}
                className="cursor-pointer p-1 hover:underline"
              >
                {link.label}
              </Link>
            )}

            {!link.isActive && <span>/</span>}
          </li>
        ))}
      </ol>
    </nav>
  )
}
